// Components==============
import InputField from 'components/UI/InputField/InputField';
import { BoxTypes } from 'components/UI/StatusBox/StatusBox';
import React, { useContext, useState } from 'react';
import { convertString } from 'utilities/convertString';
import { SoundGroupExerciseContext } from '../../SoundGroupExercise';
import './Overview.module.scss';
// =========================

const Text = ({ answer, index }: { answer: string; index: number }) => {
    const { words } = useContext(SoundGroupExerciseContext);

    const [boxState, setBoxState] = useState<BoxTypes>(
        convertString(words?.[index]?.name) === convertString(answer)
            ? 'correct'
            : 'failed'
    );
    const [value, setValue] = useState(answer);

    return (
        <div styleName="text-wrapper">
            <InputField
                boxState={boxState}
                setBoxState={setBoxState}
                handleSubmit={() => {}}
                readOnly
                value={value}
                setValue={setValue}
            />
        </div>
    );
};

export default function Overview() {
    const { userAnswers } = useContext(SoundGroupExerciseContext);

    return (
        <div styleName="wrapper">
            {userAnswers.map((answer, index) => (
                <Text key={index} answer={answer.text} index={index} />
            ))}
        </div>
    );
}
